import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Slider from "react-slick";
import icreatelogo from "../assets/images/icreatelogo.png";

// import logo from '../assets/images/logo.png'
import author1 from "../assets/images/blog/author-1.jpg";
import author2 from "../assets/images/blog/author-2.jpg";
import author3 from "../assets/images/blog/author-3.jpg";
import author4 from "../assets/images/blog/author-4.jpg";
// import author5 from "../assets/images/blog/author-5.jpg";
import axios from "axios";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from "react-hot-toast";
import "../assets/css/style.css";
import DigitalRaizpdf from "../assets/images/newimgs/1. Company Profile Final One.pdf";
import DigitalraizPvt from "../assets/images/newimgs/digitalraiz comany portfilo.pdf";
import { NavLink, useNavigate } from "react-router-dom";
import { PlayCircle } from "@mui/icons-material";

function Header() {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [form, setform] = useState({
    name: "",
    phone: "",
    email: "",
    Courses: "",
    location: "",
    planning: "",
  });
  console.log(form);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [sticky, setSticky] = useState("");

  useEffect(() => {
    const find = localStorage.getItem("finds");
    if (find == null) {
      handleShow();
    }

    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);
  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 200 ? "header-area sticky" : "";
    setSticky(stickyClass);
    console.log(stickyClass);
  };

  const classes = `${sticky}`;

  const settings1 = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    width: 500,

    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  const handlechange = (e) => {
    let myUser = { ...form };
    myUser[e.target.name] = e.target.value;
    setform(myUser);
  };

  const addUsers = () => {
    var params = {
      name: form.name,
      phone: form.phone,
      email: form.email,
      service: form.Courses,
      location: form.location,
      planning: form.planning,
    };
    axios
      .post(
        "https://icreatedegreecollege.com/api/api/user/leads/addLead",
        params,
        {}
      )
      .then((res) => {
        console.log("success");
        toast.success(
          "Added Successfully. Your data received, Our team will get back to you soon!"
        );
        handleClose();
        navigate("/thankyou");
      })
      .catch((error) => {
        const message = error?.response?.data?.message || "Something went wrong. Please try again.";
        toast.error(message);
      });
  };

  const usersSubmit = (e) => {
    e.preventDefault();
    addUsers();
  };

  return (
    <div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes modalSlideIn {
            from {
                opacity: 0;
                transform: translateY(-30px) scale(0.96);
            }
            to {
                opacity: 1;
                transform: translateY(0) scale(1);
            }
        }

        .custom-modal-size {
            max-width: 680px !important;
            margin: 2rem auto;
        }

        .custom-modal-content {
            background: linear-gradient(135deg, #7c3aed 0%, #a855f7 40%, #ec4899 100%) !important;
            color: #ffffff !important;
            border-radius: 16px !important;
            overflow: hidden;
            border: none !important;
            box-shadow:
                0 20px 60px rgba(124, 58, 237, 0.35),
                0 0 0 1px rgba(255, 255, 255, 0.08) inset !important;
            animation: modalSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .custom-modal-content .modal-header {
            border-bottom: 1px solid rgba(255, 255, 255, 0.15);
            background: rgba(0, 0, 0, 0.08);
            padding: 0.85rem 1.4rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .custom-modal-content .modal-title {
            color: #ffffff !important;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 2px;
            font-size: 0.85rem;
            margin: 0;
        }

        .custom-modal-content .close {
            color: #ffffff !important;
            opacity: 0.85;
            text-shadow: none;
            background: rgba(255, 255, 255, 0.15) !important;
            width: 30px;
            height: 30px;
            padding: 0 !important;
            border-radius: 50% !important;
            margin: 0 !important;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.1rem;
            line-height: 1;
            transition: all 0.2s ease;
            border: none;
        }

        .custom-modal-content .close:hover {
            opacity: 1;
            background: rgba(255, 255, 255, 0.3) !important;
            transform: rotate(90deg);
        }

        .custom-modal-content .modal-body {
            padding: 4px 20px 8px 20px !important;
            background: transparent !important;
        }

        .custom-form-group {
            margin-bottom: 0.4rem !important;
        }

        .custom-form-group label {
            display: block;
            margin-bottom: 0.1rem !important;
            font-size: 0.65rem !important;
            font-weight: 700 !important;
            color: rgba(255, 255, 255, 0.9) !important;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

        .custom-form-group label abbr {
            color: #fbbf24 !important;
            text-decoration: none !important;
        }

        .input-with-icon {
            position: relative;
        }

        .input-with-icon i, .input-with-icon span {
            position: absolute;
            left: 0.75rem;
            top: 50%;
            transform: translateY(-50%);
            color: rgba(255, 255, 255, 0.7);
            font-size: 0.85rem;
            z-index: 10;
            transition: color 0.2s ease;
        }

        .input-with-icon:focus-within i, .input-with-icon:focus-within span {
            color: #ffffff;
        }

        .custom-form-control {
            width: 100%;
            background: rgba(255, 255, 255, 0.12) !important;
            border: 1px solid rgba(255, 255, 255, 0.2) !important;
            border-radius: 8px !important;
            padding: 0.55rem 0.2rem 0.5rem 2.2rem !important;
            color: #ffffff !important;
            font-size: 0.85rem !important;
            height: auto !important;
            transition: all 0.25s ease !important;
            backdrop-filter: blur(4px);
            line-height: normal;
        }

        .custom-form-control::placeholder {
            color: rgba(255, 255, 255, 0.5) !important;
            font-size: 0.82rem;
        }

        .custom-form-control:focus {
            border-color: rgba(255, 255, 255, 0.5) !important;
            background: rgba(255, 255, 255, 0.18) !important;
            box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.08) !important;
            outline: none;
        }

        .custom-form-control option {
            background: #7c3aed;
            color: #ffffff;
        }

        .custom-submit-btn {
            background: #ffffff !important;
            border: none !important;
            border-radius: 8px !important;
            padding: 10px !important;
            font-weight: 700 !important;
            color: #7c3aed !important;
            text-transform: uppercase;
            letter-spacing: 0.8px;
            font-size: 0.82rem !important;
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12) !important;
            transition: all 0.25s ease !important;
            cursor: pointer;
            width: auto !important;
            min-width: 200px;
        }

        .custom-submit-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
            background: #f8fafc !important;
        }

        .right-panel-offer {
            padding: 10px;
            background: rgba(255, 255, 255, 0.08) !important;
            border: 1px solid rgba(255, 255, 255, 0.15) !important;
            border-radius: 12px !important;
            height: 100%;
            color: #ffffff !important;
            backdrop-filter: blur(6px);
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .right-panel-offer h3 {
            color: #ffffff !important;
            font-size: 1rem !important;
            margin-bottom: 6px !important;
            font-weight: 700 !important;
        }

        .right-panel-offer h4 {
            color: #fbbf24 !important;
            font-size: 0.88rem !important;
            margin-bottom: 14px !important;
            font-weight: 700 !important;
            line-height: 1.3;
        }

        .promo-badge {
            background: rgba(255, 255, 255, 0.95) !important;
            color: #7c3aed !important;
            padding: 8px 12px;
            border-radius: 8px;
            margin-bottom: 14px;
            font-size: 0.78rem;
            font-weight: 700;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        .right-panel-offer .btn-light {
            border-radius: 10px !important;
            padding: 8px 16px !important;
            font-size: 0.8rem !important;
            color: #7c3aed !important;
            font-weight: 700 !important;
            transition: all 0.2s ease;
        }

        @media (max-width: 767px) {
            .custom-modal-size {
                max-width: 92vw !important;
                margin: 1rem auto;
            }
        }
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
select:-webkit-autofill {
    -webkit-text-fill-color: #ffffff !important;
    caret-color: #ffffff !important;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    transition: background-color 9999s ease-in-out 0s !important;
}

input:-internal-autofill-selected {
    background-color: transparent !important;
}
      `,
        }}
      />

      <header className={classes} id="header-area">
        <nav className="navbar navbar-expand-md fixed-top">
          <div className="container">
            <div className="row" style={{ width: "100%" }}>
              <div className="col-3">
                <div className="pict">
                  <NavLink to="/" className="navbar-brand">
                    <img
                      src={icreatelogo}
                      className="img-fluid moblogoimg"
                      alt="Img"
                      id="pict"
                      width={150}
                    />
                  </NavLink>
                </div>
              </div>
              <div className="col-9">
                {/* <a className="btn themes-btn btn-block headbtn" style={{border:"none",background:"none"}}><a  className=''><i class="fa fa-phone mr-1" aria-hidden="true"></i>+91 9494613601</a></a> */}
                <div className="headtab" style={{ float: "right" }}>
                  {/* <p> <i class="fa fa-phone mr-1" aria-hidden="true"></i>+91 9494613601</p> */}
                  <div className="row mt-3 mobtab">
                    <div
                      className="col-4 mobileslider"
                      style={{ marginTop: "10px" }}
                    >
                      <a
                        href="tel:+91 83 67 215 215"
                        className="contactnumber "
                      >
                        {" "}
                        <i className="fa fa-phone mr-1 " aria-hidden="true"></i>+91
                        83 67 215 215
                      </a>
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 headerbtnsm">
                      <div className="control-form">
                        <a
                          href="https://www.instagram.com/icreate12/"
                          target="_blank"
                        >
                          <button
                            className="btn themes-btn btn-block headbtn"
                            id="btn2"
                          >
                            <a className="btna">
                              icreate12{" "}
                              <i className="fa fa-instagram" aria-hidden="true"></i>
                            </a>
                          </button>
                        </a>
                      </div>
                    </div>

                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">
                      <div className="control-form btnmar ">
                        <a href="https://www.icreateedu.in/" target="_blank">
                          <button className="btn theme-btn btn-block headbtn1">
                            <span className="btna text-white">
                              www.icreateedu.in
                              <i
                                className="fa fa-arrow-right ml-1"
                                aria-hidden="true"
                              ></i>
                            </span>
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal-size"
        contentClassName="custom-modal-content"
      >
        <div className="modal-header">
          <h5 className="modal-title">
            <i
              className="fa fa-graduation-cap"
              style={{ marginRight: "8px", opacity: 0.8 }}
            ></i>{" "}
            icreate college
          </h5>
          <button
            type="button"
            className="close"
            onClick={handleClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-md-5 d-md-block d-none p-1">
              <div className="right-panel-offer">
                <div className="text-center mb-2">
                  <a href="">
                    <img
                      src={icreatelogo}
                      alt="Logo"
                      style={{ maxWidth: "120px", marginBottom: "8px" }}
                    />
                  </a>
                  <h3
                    style={{
                      fontSize: "0.95rem",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    Our Students Love Us
                  </h3>
                  <div
                    style={{
                      height: "2px",
                      width: "30px",
                      background: "#fbbf24",
                      margin: "6px auto",
                    }}
                  ></div>
                </div>

                <div
                  className="testimonial-slider-wrapper"
                  style={{ padding: "0 10px" }}
                >
                  <Slider {...settings1}>
                    <div className="item" style={{ outline: "none" }}>
                      <p
                        style={{
                          fontSize: "0.8rem",
                          lineHeight: "1.4",
                          fontStyle: "italic",
                          marginBottom: "8px",
                          color: "rgba(255,255,255,0.9)",
                        }}
                      >
                        "One of fantastic college 🎉and management 👍👍best education ✍️"
                      </p>
                    </div>
                    <div className="item" style={{ outline: "none" }}>
                      <p
                        style={{
                          fontSize: "0.8rem",
                          lineHeight: "1.4",
                          fontStyle: "italic",
                          marginBottom: "8px",
                          color: "rgba(255,255,255,0.9)",
                        }}
                      >
                        " I create business school 🏫 is very helpful to my career feel really motivated when I am in Business School. The school has a very 💪strong motivating and performing 💯atmosphere and will help its students progress in their choosen career paths.and teacher are very good 💯 😊"
                      </p>
                    </div>
                    <div className="item" style={{ outline: "none" }}>
                      <p
                        style={{
                          fontSize: "0.8rem",
                          lineHeight: "1.4",
                          fontStyle: "italic",
                          marginBottom: "8px",
                          color: "rgba(255,255,255,0.9)",
                        }}
                      >
                        "One of the finest college for commerce and management studies. This college literally shows how studies correlates with real time .Thank u to all the experienced faculties and the management for their support.I personally recommend to join my upcoming generation to choose a college like this."
                      </p>
                    </div>
                    <div className="item" style={{ outline: "none" }}>
                      <p
                        style={{
                          fontSize: "0.8rem",
                          lineHeight: "1.4",
                          fontStyle: "italic",
                          marginBottom: "8px",
                          color: "rgba(255,255,255,0.9)",
                        }}
                      >
                        "feel really motivated when I am in Business School. The school has a very strong motivating and performing atmosphere and will help its students progress in their choosen career paths."
                      </p>
                    </div>
                    <div className="item" style={{ outline: "none" }}>
                      <p
                        style={{
                          fontSize: "0.8rem",
                          lineHeight: "1.4",
                          fontStyle: "italic",
                          marginBottom: "8px",
                          color: "rgba(255,255,255,0.9)",
                        }}
                      >
                        "Faculty is very supportive and they creates a positive vibes with their attention and inspire the students"
                      </p>
                    </div>
                  </Slider>
                </div>

                <div
                  className="text-center mt-2 pt-1"
                  style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}
                >
                  <div className="mt-1">
                    <a
                      target="_blank"
                      href="https://wa.me/918367215215"
                      rel="noreferrer"
                      className="btn btn-light btn-sm font-weight-bold"
                      style={{
                        borderRadius: "8px",
                        padding: "4px 12px",
                        fontSize: "0.75rem",
                      }}
                    >
                      <i className="fa fa-whatsapp mr-1 text-success"></i>
                      Chat on WhatsApp
                    </a>
                  </div>
                  <small
                    className="d-block my-2"
                    style={{ color: "#fff", fontSize: "0.62rem", opacity: 0.8 }}
                  >
                    Join 500+ Happy Students
                  </small>
                  <div
                    className="d-flex justify-content-center align-items-center flex-wrap"
                    style={{ gap: "12px", marginBottom: "8px" }}
                  >
                    <a
                      href="tel:+918367215215"
                      className="text-white"
                      style={{
                        fontSize: "0.89rem",
                        fontWeight: "600",
                        textDecoration: "none",
                      }}
                    >
                      <i
                        className="fa fa-phone mr-1 text-warning"
                        style={{ fontSize: "0.75rem" }}
                      ></i>
                      +91 8367215215
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-12 p-1">
              <div className="d-md-none text-center mb-2">
                <img src={icreatelogo} alt="Logo" width={150} />
              </div>
              <h3 className="text-white mb-0" style={{ fontSize: "20px", fontWeight: "700" }}>
                Welcome to icreate College
              </h3>
              <p className="text-white mb-2" style={{ fontSize: "12px", opacity: 0.9 }}>
                Fill out the form to get started..
              </p>
              <form onSubmit={usersSubmit}>
                <div className="row no-gutters">
                  <div className="col-md-6 col-12 px-1">
                    <div className="form-group custom-form-group">
                      <label htmlFor="modal-fname">
                        Full Name <abbr>*</abbr>
                      </label>
                      <div className="input-with-icon">
                        <input
                          type="text"
                          id="modal-fname"
                          name="name"
                          pattern="^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$"
                          className="form-control custom-form-control"
                          placeholder="Full Name"
                          value={form.name}
                          onChange={handlechange}
                          required
                          autoComplete="on"
                        />
                        <i className="fa fa-user"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-12 px-1">
                    <div className="form-group custom-form-group">
                      <label htmlFor="modal-phone">
                        Mobile <abbr>*</abbr>
                      </label>
                      <div className="input-with-icon">
                        <input
                          type="text"
                          id="modal-phone"
                          name="phone"
                          minLength="10"
                          maxLength="10"
                          pattern="\d{10}"
                          className="form-control custom-form-control"
                          placeholder="Mobile No..."
                          value={form.phone}
                          onChange={handlechange}
                          required
                          autoComplete="on"
                        />
                        <i className="fa fa-phone"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-12 px-1">
                    <div className="form-group custom-form-group">
                      <label htmlFor="modal-course">
                        Course <abbr>*</abbr>
                      </label>
                      <div className="input-with-icon">
                        <select
                          id="modal-course"
                          className="form-control custom-form-control"
                          name="Courses"
                          value={form.Courses}
                          onChange={handlechange}
                          required
                        >
                          <option value="">Select Course</option>
                          <option value="BBA">BBA</option>
                          <option value="BBA-CAT">BBA-CAT</option>
                          <option value="BBA-EDP">BBA-EDP</option>
                          <option value="BBA-SAP">BBA-SAP</option>
                          <option value="BBA-GME">BBA-GME</option>
                          <option value="BBA-ACCA">BBA-ACCA</option>
                          <option value="BBA-CWE">BBA-CWE</option>
                          <option value="B.COM-COMPUTERS">B.COM-COMPUTERS</option>
                          <option value="BBA Analytics">BBA Analytics</option>
                          <option value="Food & Nutrition">Food & Nutrition</option>
                          <option value="Hotel Management">Hotel Management</option>
                        </select>
                        <i className="fa fa-graduation-cap"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-12 px-1">
                    <div className="form-group custom-form-group">
                      <label htmlFor="modal-location">
                        Location <abbr>*</abbr>
                      </label>
                      <div className="input-with-icon">
                        <input
                          type="text"
                          id="modal-location"
                          className="form-control custom-form-control"
                          name="location"
                          value={form.location}
                          onChange={handlechange}
                          placeholder="Location"
                          required
                        />
                        <i className="fa fa-location-arrow"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-12 px-1">
                    <div className="form-group custom-form-group">
                      <label htmlFor="modal-planning">
                        Planning <abbr>*</abbr>
                      </label>
                      <div className="input-with-icon">
                        <select
                          id="modal-planning"
                          className="form-control custom-form-control"
                          name="planning"
                          value={form.planning}
                          onChange={handlechange}
                          required
                        >
                          <option value="">Select Planning</option>
                          <option value="Immediately">Immediately</option>
                          <option value="15 days">Within 15 days</option>
                          <option value="30 days">Within 30 days</option>
                        </select>
                        <i className="fa fa-calendar"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-center mt-3">
                  <button type="submit" className="custom-submit-btn">
                    Submit Request{" "}
                    <i
                      className="fa fa-paper-plane"
                      style={{ marginLeft: "6px" }}
                    ></i>
                  </button>
                </div>
                <p className="visible1" onClick={handleClose} style={{ cursor: "pointer", opacity: 0.1, margin: 0, fontSize: "8px", textAlign: "center" }}>
                  .
                </p>
              </form>
            </div>
          </div>
        </div>
      </Modal>

      <Toaster position="top-right" reverseOrder={false} />
    </div>
  );
}

export default Header;
